"use strict";

module.exports = function (accumulator) {
  return accumulator + '\nDO NOT SHRINK\n';
};